import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';
import {Page} from '../model/page';
import {RestService} from '../providers/rest.service';
import {UrunGrup} from '../model/urun-grup';
import {Sube} from '../model/sube';
import {Router} from '@angular/router';

@Component({
  selector: 'app-urun-gruplar',
  templateUrl: './urun-gruplar.component.html',
  styleUrls: ['./urun-gruplar.component.css']
})
export class UrunGruplarComponent implements OnInit {
  urunGruplar: UrunGrup[] = null;

  constructor(private helperProvider: HelperProvider,
              private restService: RestService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.UrunGruplar);

    this.getUrunGruplar();
  }

  getUrunGruplar() {
    this.restService.urunGruplar(null).subscribe(res => {
      if (res != null) {
        this.urunGruplar = res;
      }
    });
  }

  kaldir(s: UrunGrup) {
    if (confirm(`${s.isim} ürün grubunu silmek istediğinize emin misiniz?`)) {
      this.restService.urunGrupSil(s.id).subscribe(res => {
        if (res) {
          this.getUrunGruplar();
        }
      });
    }
  }

  incele(s: UrunGrup) {
    this.router.navigate(['urun-grup'], {queryParams: {id: s.id}});
  }

  new() {
    this.router.navigate(['urun-grup'], {queryParams: {id: '0'}});
  }
}
